import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore'; // for the db
import 'firebase/compat/auth';

const config = {
  apiKey: 'AIzaSyB3h4_MRNLy2uC_dHflfAFB2P1FUmJngyw',
  authDomain: 'masjid-brixton.firebaseapp.com',
  projectId: 'masjid-brixton',
  storageBucket: 'masjid-brixton.appspot.com',
  messagingSenderId: '303695367422',
  appId: '1:303695367422:web:74f84858053a3c3210e9af',
};

firebase.initializeApp(config);

const firestore = firebase.firestore();
const auth = firebase.auth();

const createUserProfileDocument = async (userAuth, additionalData) => {
  if (!userAuth) {
    return;
  }

  const userRef = firestore.doc(`users/${userAuth.multiFactor.user.uid}`); //users/uniq26535
  const snapShot = await userRef.get();

  if (!snapShot.exists) {
    const { displayName, email } = userAuth;
    const createdAt = new Date();

    try {
      await userRef.set({
        displayName,
        email,
        createdAt,
        ...additionalData,
      });
    } catch (error) {
      console.log('error creating user', error.message);
    }
  }

  return userRef;
};

export { firestore, createUserProfileDocument, auth };
